const applyFilters = (data, values) => {
	if (!data || !Array.isArray(data)) return data;

	const result = data.filter((item) => values.includes(item.category.service_category_id));
	return result;
};

export default applyFilters;
